import { useFormik } from "formik";
import { Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";

import { useAlert, useAxios, useComponent } from "../../../hooks";
import { formData } from "./form components/IndependentAppointmentBookingObject";
import validationSchema from "./form components/IndependentAppointmentBookingObject";
import IndependentAppointmentForm from "./form components/IndependentAppointmentForm";
import pages from "../../../constants/pages";
import { Loader } from "../../../components";

const MyComponent = () => {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loader } = useComponent();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(location.search);

  const premisesID = queryParams.get("premises_id");

  const [stepperLevel, setStepperLevel] = useState(0);
  const [customFields, setCustomFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [officerOptions, setOfficerOptions] = useState([]);

  const onSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    const name = values.name.split(" ");
    axios({
      url: "/appointment/appointment/book-appointment",
      method: "POST",
      data: {
        reference_visitor_id: visitorData?.ID,
        appointment_type: "open",
        visitors: [
          {
            mobile: visitorData?.phoneNumber,
            first_name: name[0] || "",
            last_name: name.slice(1).join(" ") || "",
            officer_id: values?.officer,
            purpose: values?.reason,
            designation: "",
            organization_name: "",
            total_bookings: 1,
            appointment_date: new Date()?.getTime() / 1000,
          },
        ],
      },
      disableRedirect: true,
    })
      .then((response) => {
        if (response?.status) {
          dispatch(
            alert({
              type: "success",
              message: response?.message?.displayMessage,
            })
          );

          navigate(
            `${pages?.checkLiveliness?.route}?visitor_id=${response?.data?.visitor_id}&booking_id=${response?.data?.reference_appointment_id}&entity_id=${response?.data?.premises_id}&user_type_id=2&indepentent=true&doc_face=true`
          );
        } else {
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: formData,
    validationSchema: validationSchema(customFields),
    enableReinitialize: true,
    onSubmit,
  });

  const [officials, setOfficials] = useState([]);

  useEffect(() => {
    if (premisesID) {
      loader.start();
      axios({
        url: `/appointment/appointment/get-premises-officers?premises_id=${premisesID}`,
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response?.status) {
          setOfficerOptions(response.data);
          const officerData = response.data[0];
          if (!officerData) {
            loader.apiComplete();
            return;
          }

          axios({
            url: `admin/custom-fields/get-appointment-fields?business_id=${officerData.business_id}`,
            disableError: true,
            disableRedirect: true,
          }).then((response) => {
            if (response.status) {
              setCustomFields(response.data);
            }
            loader.apiComplete();
          });
        } else {
          loader.apiComplete();
        }
      });
    }
  }, [premisesID]);

  return (
    <Fragment>
      <Loader>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
          sx={{
            // minHeight: "100vh",
            background: "#ffffffff",
            fontFamily: "Fira Sans, Montserrat, sans-serif",
            py: { xs: 2, sm: 4 },
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            sx={{
              width: { xs: "92%", sm: "420px" },
              maxWidth: "420px",
              mx: "auto",
            }}
          >
            {/* Banner */}
            <Box
              component="img"
              src={
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAllBMVEX///8mJykAAAAmJysjJCYnJykGCA3//v/Iycnf398gISMXGBsAAAcZGh0lKCpISUsNDxJAQUMSFBfS0tKHh4np6emqqqq/v7/39/csLS+2trZYWFng4OBSUlTX19ceICB6e3wzNDZtbW2enp/u7/BlZmiVlpimpqaGhoePj5A7PD4yMzW6urtWWFdXV1lMTE92dnUVGBa2GMXKAAAGfUlEQVR4nO2Z6XLqOBCFJSEvyDbIJoAx+5aw3ZC8/8tNt2QTstypmT8XT835qlKRsJCl41YvWAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/H/olo9eQcsYvvTV6NGLaBO70dRaYy+PXkd7WKyVNTII7PjRK2kPXZtJSZqE8aNX0iKizVLKjoQm9wxCaPKVroImX4Em34Em34Em34Em34EmN4ZN47+uSbm4jKp45tpR9NOIKCojwX/c9rXuLh5tt6N4eDeqrE6K/nW3z4tPmtCcZbkbLuLq+dF18mDSn//69WtKvL6+uv/T+bWfn5YzMT315/P59XSl2uRNK6XSMO1XtPpgnfe/kOen9STciq1d58RakXrVa5imKrWh6o/8PqPBSodZLnZ7ZQtVzT40WbxPJjqzKd1FLR4rieie1ZIxJimCiQmtcdjlfChWuqBmOjmIlcpMOF/NrTRqH4mNqYeZYn06mZAa2ujMvMZifM3465N9Ga9Do+38uCl0YGxAG++uZEoljs4rw5WOPs3SmybD6dpoKRPzFO8eLAnRPRkuxcyeH+VuVVBHJlt/bZUF4VhEfdLixE9vZGVgN/S8D26Ylm79ceEmmPrvxFbaZyG2iqa1PM9iSZvVaitGSvO3Aq0sN/S5m977k1xrtXr0ualZpG5Lfd+7ml6vlx18Z28K2t41kzrZ0ZmJxFrLQPEechZS2pn7dFvwTicRI0aFmZN6KujIbONmqUIeqyoxTmjuXpA9vWQ0pX0b3vvYF2uy9njb/dKteeA6vD+pjXteu5Qbz7SlRqRcBzJ7o8bY7TNbUTMSi5C2JkP/29DVpLHgUyFl6qcUay/gjuyOG0Uphnv1vinZn0jWhPzyWBX9oWgNXbc0s3edg1u2feH2S0FmsnMi9UdVVY02WRBIk/M1byhqx5rEThM2D5osZYvbO4eR1Tc4JtTrFEffkIY/25XNjZ2dxCrb/xjNHsXG6ZCyx4gm7szrCX9O7rMkm3YWwQFBhVmWJfbE18bOEpIja/KWsSbe0o5FOhY7r/K1nj92RqVPXhOtm/t+aBJbXWz/+L7/jq7bnzv9FQURZwAXdjTFkxBT44zo6XA4PDmOPlb23bh3MpRhqJNOY2mTZd6crNryeIB0c5YfmjjX4zXJni6rUPdk0aKjIxpDUV0hzsnGi0A7WyUF7Viy4aRf1xvV+34nQzkUE+eFJGUW45Tdiu86x8OUCftSqWYfZ+dOExmqJOj16rPXGuoHticzUbM4DViFuHxPVrT45N5b3pObHnuecmjJ+5y1t7TX7EyXnoub4TGllrTnRhNt7m/bo/N3eXcHNnz+I5v9pzifSCf7VNCznTtDeX2xKafyGa/3p8PuDCVIjodkEnHmwsMu1vLbGm8ntwdfSu002f2oCfmTyhvMwzPYTwycR9HGhDOOAW5H2j9nF2D06YcvuWRPUtbKMvRcGpZpzVHcnyvdqweWGduJXoovmswaTcTGH6pzS1I2j3MiPZ9weEPpBP6xPbnl2jtDaXyLz8UoRlHpVxuKLJz9+7hz80LkY0kTkvi3mpTu7MlkI1rEoLZet4uYraZTJ+uL2hG+NENXqq6OOasl12n9u00XxPW7r1Y2GSWssqjfevpYTPnvd006dX7S3L9VAdmF1iZSuE5Th/igJMN9zJbd3au8+c7Idjp1KiN8HuPtTLg8tldndxSYWIqEIvPRTdWkcpwDsKbuPeDW6Rak7Unv6xwsHH50bi6knLgiUVLRfMpNmnzkEZHRncZMKLhoDi31pcrVe/bI7RlvNzmRom8+SW4q37FlTQq2wMif3kDbNolCvrR5yoJPhb297h+uXRhx6ZbOkoW4JeHboqPPTYcC8C1L4/1ywApXi+GFTpVRUypyxt7iMvqwFOViTLfssD+qBqVYrPyb0iCcbuO2uNpLepeZVWFdBjqiJ2v51w1tErW//3mjzHRa3TpWq7s0ZrcqbGaKlAqCIs0pkXtTynqoSthT5Uy1giNVqiqbTsg1RGts5aQOt3Z5Vp8SqOFof07ssn/8kkE8fzgX8hZq+unirlpdyUby/bOTKt5yHekYbcdiWI3HcTwYDOJ4XO3ExXe4P67aYickxG87jh9/hW1VLQsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAf89f2L1nqm5zcBsAAAAASUVORK5CYII="
              }
              alt="Event Banner"
              sx={{
                mt: 2,
                mb: 3,
                width: "100%",
                maxWidth: "100%",
                borderRadius: 3,
                boxShadow: 2,
                height: "20vh",
                objectFit: "cover",
                marginTop: 4,
              }}
            />
          </Box>
        </Box>

        <Grid container justifyContent={"center"}>
          <Grid
            item
            md={12}
            sl={6}
            sx={{
              "@media (min-width: 950px)": {
                width: "50%",
              },
            }}
            padding={5}
          >
            <Fragment>
              <Grid container className="subheaderSectionBox">
                <Typography
                  variant={"h3"}
                  sx={{
                    marginBottom: "5px",
                    textAlign: "left",
                    color: "black",
                    "-webkit-text-stroke-width": ".5px",
                    fontWeight: 400,
                    fontFamily: "georgia serif",
                  }}
                >
                  Visitor Pass
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    alignContent: "center",
                    textAlign: "left",
                    color: "gray",
                    "@media (min-width: 547px)": { marginLeft: "20px" },
                  }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: "Please register to get your visitor pass." || "",
                    }}
                  />
                </Typography>
              </Grid>
            </Fragment>

            <form
              style={{ width: "100%" }}
              onSubmit={(event) => {
                event.preventDefault();
                formik.handleSubmit();
              }}
            >
              <IndependentAppointmentForm
                formik={formik}
                premisesID={premisesID}
                officials={officials}
                setCustomFields={setCustomFields}
                setStepperLevel={setStepperLevel}
                loading={loading}
                officerOptions={officerOptions}
                setOfficerOptions={setOfficerOptions}
              />
            </form>
          </Grid>
        </Grid>
      </Loader>
    </Fragment>
  );
};

export default MyComponent;
